<template>
  <div class="message-over-view">
    <div class="message-over-view-line" style="height: 280px;align-items: center">
      <div style="width: 40%;border: 1px solid #eeeeee;border-radius: 10px;padding: 10px 0;">
        <common-ring commonRingId="messageRing" :height="'260px'" :colorList="messageColorList" :ringLegend="messageRingLegend" :ringTitle='messageTitle' :ringData='messageInfo' />
      </div>
      <div class="message-person-count-box">
        <div class="message-person-count">{{wxTemplateCount}}</div>
        <div class="message-person-tip">模板数量</div>
      </div>
      <div class="message-person-count-box">
        <div class="message-person-count">{{totalSendMessageCount}}</div>
        <div class="message-person-tip">推送数量</div>
      </div>
    </div>

    <div class="finance-over-view-line" style="height: 280px;margin: 60px 0 20px 0;padding: 10px;position: relative;border: 1px solid #eeeeee;border-radius: 10px;">
      <div style="position: absolute;top: 15px;right: 0;left: 0;margin: 0 auto;z-index: 1001;width: 180px;">
        <el-switch
          v-model="messageAccessRecordRadio"
          active-text="年度"
          inactive-text="月度">
        </el-switch>
      </div>
      <common-line style="z-index: 1000" lineId='messageAccessRecordLine' :height='"260px"' :lineTitle='messageAccessRecordTitle' :legendData="messageAccessRecordLegendData" :xAxis="messageAccessRecordXAxis" :yAxis='messageAccessRecordYAxis' :series='messageAccessRecordSeries' />
    </div>

  </div>

</template>

<script>
  import CommonRing from '../../../components/Echarts/Pie/Pie/commonRing'
  import {api} from '../../api/Message'
  import {errorHandler} from '../../../utils/errorHandler'
  import CommonLine from '../../../components/Echarts/Line/commonLine'

  export default {
    components: {
      CommonLine,
      CommonRing},
    name: 'message-over-view',
    data () {
      return {
        messageColorList: ['#5B9BD5', '#ED7D31', '#C2A753', '#4BB66E', '#FFA336', '#53A5BC', '#47C4CA', '#77E5BF', '#82D74C', '#A4C344'],
        messageRingLegend: {
          left: 'center',
          bottom: -5,
        },
        messageTitle: '消息推送数量',
        messageInfo: [],

        totalSendMessageCount: 0,
        wxTemplateCount: 0,

        messageAccessRecordRadio: false,
        messageAccessRecordTitle: '推送统计',
        messageAccessRecordLegendData: ['推送成功', '推送失败'],
        messageAccessRecordXAxis: {
          type: 'category',
          name: '日期',
          data: []
        },
        messageAccessRecordYAxis: [
          {
            type: 'value',
            name: '数量',
            splitLine: {
              show: false
            },
          }
        ],
        messageAccessRecordSeries: [],

      }
    },
    mounted () {
      this.getStatistics()
      this.getMessageRecordSendStatistics(1)
    },
    methods: {
      getStatistics () {
        this.$axios.get(api.getStatistics, {})
          .then(res => {
            let data = res.data.data
            this.totalSendMessageCount = data.totalSendMessageCount
            this.wxTemplateCount = data.wxTemplateCount
            let messageInfo = [
              { name: '智慧门禁', code: 'MJ', value: 0 },
              { name: '智慧用电', code: 'YD', value: 0 },
              { name: '智慧梯控', code: 'TK', value: 0 },
              { name: '智慧缴费', code: 'JF', value: 0 },
              { name: '智慧合约', code: 'ZS', value: 0 },
              { name: '智慧预约', code: 'YY', value: 0 },
              { name: '智慧报修', code: 'BX', value: 0 },
              { name: '智慧凭证', code: 'FP', value: 0 },
              { name: '智慧活动', code: 'HD', value: 0 },
              { name: '其他', code: 'QT', value: 0 },
            ]
            messageInfo.map(v => {
              for(let key in data.recordCountGroupByModel) {
                if (v.code === key) {
                  v.value = data.recordCountGroupByModel[key]
                }
              }
            })
            this.messageInfo = messageInfo
          })
          .catch(errorHandler('获取数据失败'))
      },

      getMessageRecordSendStatistics (type) {
        this.$axios.get(`${api.getMessageRecordSendStatistics}/${type}`, {})
          .then(res => {
			      let data = res.data.data
            let xData = []
            let successSeriesData = []
            let failSeriesData = []
            data.map(v => {
              successSeriesData.push(v.successNumber)
              failSeriesData.push(v.failNumber)
              if (type === 1) {
                let dateArr = v.time.split('-')
                let showData = `${dateArr[1]}-${dateArr[2]}`
                xData.push(showData)
              } else {
                xData.push(v.time)
              }
            })
            this.messageAccessRecordXAxis.data = xData
            this.messageAccessRecordSeries = [
              {
                name: '推送成功',
                type: 'line',
                stack: '总量',
                // areaStyle: {},
                smooth:true,
                symbol: 'circle',
                symbolSize: 5,
                sampling: 'average',
                itemStyle: {
                  color: '#00A0E6'
                },
                areaStyle: {
                  color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                    offset: 0,
                    color: '#00A0E6'
                  }, {
                    offset: 1,
                    color: '#ffe'
                  }])
                },
                data: successSeriesData
              },
              {
                name: '推送失败',
                type: 'line',
                stack: '总量',
                // areaStyle: {},
                smooth:true,
                symbol: 'circle',
                symbolSize: 5,
                sampling: 'average',
                itemStyle: {
                  color: '#FFA336'
                },
                areaStyle: {
                  color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                    offset: 0,
                    color: '#FFA336'
                  }, {
                    offset: 1,
                    color: '#ffe'
                  }])
                },
                data: failSeriesData
              }
            ]
          })
          .catch(errorHandler('获取数据失败'))
      },

    },
    watch: {
      messageAccessRecordRadio (val) {
        if (!val) {
          this.getMessageRecordSendStatistics(1)
        } else {
          this.getMessageRecordSendStatistics(2)
        }
      },

    }

  }
</script>


<style lang="less">
  .message-over-view {
    padding: 20px 2%;
    .message-over-view-line {
      display: flex;
      justify-content: space-between;
      .message-person-count-box {
        width: 200px;
        height: 80px;
        padding: 10px 10px;
        border-radius: 10px;
        color: #ffffff;
        background-color: #00A0E6;
        display: flex;
        justify-content: space-between;
        flex-direction: column;
        .message-person-count {
          font-size: 32px;
          font-weight: 500;
        }
        .message-person-tip {
          font-size: 14px;
        }
      }
      .message-over-view-line-left {
        width: 49%;
        padding: 10px 10px;
        border: 1px solid #eeeeee;
        border-radius: 10px;
        display: flex;
        justify-content: space-between;
        overflow: hidden;
      }
      .message-over-view-line-right {
        width: 49%;
        padding: 10px 10px;
        border: 1px solid #eeeeee;
        border-radius: 10px;
        overflow: hidden;
      }

      .el-table {
        thead {
          th {
            padding: 6px 0;
            text-align: center;
            color: #666666;
            background-color: #eff1f5;
          }
        }
        tbody {
          td {
            padding: 6px 0;
            text-align: center;
            color: #FF0000;
          }
        }
      }

      .el-pagination {
        padding: 0;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/view/MessageService/MessageOverView/MessageOverView.vue